<template lang="pug">
modal(ref="modal", id="editPricebookProduct", :loading="loading")
    template(slot="title") Edit Product
    template(slot="body")
        div(v-if="product !== null")
            .row
                .col-md-12
                    img.w-70.img-responsive.pull-left.m-r-md(:src="productImg(product)")
                    span.clear._500.m-t-sm {{ product.name }}
                    span.text-muted.clear {{ product.code }}
            include pricebook-product-form
    template(slot="footer")
        button.btn.btn-fw.green(
            @click="submit",
            :disabled="loading"
        )
            v-loading(loader="save-pricebook-entry") Save

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ProductMixin from '@js/mixins/products';

export default {
    mixins: [ProductMixin],

    data() {
        return {
            product: null,
        };
    },

    computed: {
        ...mapGetters('pricebook', ['pricebook']),

        loading() {
            return this.onLoading('save-pricebook-entry');
        },
    },

    mounted() {
        this.$on('show', product => {
            const p = _.cloneDeep(product);
            this.$set(p, 'hidden', p.pivot.hidden);

            if (p.price_type == 1) {
                this.$set(p, 'override_unit_price', p.pivot.unit_price);
            } else if (p.price_type == 0) {
                p.variants.forEach(v => {
                    this.$set(v, 'override_cost', v.variant_entry.cost);
                    this.$set(v, 'override_price', v.variant_entry.price);
                    this.$set(v, 'hidden', v.variant_entry.hidden);
                });
            }

            this.product = p;
            this.$refs.modal.$emit('show');
        });
    },

    methods: {
        ...mapActions('pricebook', ['saveProductVariantEntry']),

        async submit() {
            const validate = await this.$validator.validate();

            if (!validate) return;

            try {
                await this.saveProductVariantEntry(this.product);
                this.showToastrSuccess('Product has successfully updated');
                this.$emit('entry-saved');
                this.$refs.modal.$emit('hide');
            } catch (e) {
                this.showApiError(e);
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/pricebook/pricebook-edit-product.vue